import { createTheme } from "@mui/material";

export const defaultTheme = createTheme({
  palette: {
    primary: {
      main: "#1EA097",
      light: "#1EA097",
      dark: "#1EA097",
      contrastText: "#1EA097",
    },
    grey: {
      50: "#F9FAFB",
      100: "#F3F4F6",
      200: "#F0F0F0",
      300: "#E5E7EB",
      400: "#D1D5DB",
      500: "#6B7280",
      600: "#4B5563",
      700: "#374151",
      800: "#1F2937",
      900: "#111827",
    },
    info: {
      main: "#FFFFFF"
    }
  }
});